import r from "../managers/braze-instance.js";
import { logger as N, IndexedDBAdapter as st } from "../../shared-lib/index.js";
import ne, { STORAGE_KEYS as s } from "../managers/storage-manager.js";
export function enableSDK() {
  new ne.se(null, !0).remove(s.me);
  const e = st.Ls.Fs;
  new st(e, N).ge(e.Ms.pe, e.be),
    N.info("enableSDK was called"),
    r.destroy(!1),
    r.fe(!1);
}
